import { queryOptions, type QueryClient } from '@tanstack/react-query'
import { api, type Channel } from '../api/client'

// Channel queries shared by the sidebar, browse dialog and channel page.

export const myChannelsQuery = queryOptions({
  queryKey: ['channels', 'mine'],
  queryFn: async () => {
    const { data, response } = await api.GET('/channels', { params: { query: { filter: 'mine' } } })
    if (!data) throw new Error(`GET /channels failed: ${response.status}`)
    return data.channels
  },
})

export const browseChannelsQuery = queryOptions({
  queryKey: ['channels', 'browse'],
  queryFn: async () => {
    const { data, response } = await api.GET('/channels', { params: { query: { filter: 'browse' } } })
    if (!data) throw new Error(`GET /channels failed: ${response.status}`)
    return data.channels
  },
})

export const archivedChannelsQuery = queryOptions({
  queryKey: ['channels', 'archived'],
  queryFn: async () => {
    const { data, response } = await api.GET('/channels', { params: { query: { filter: 'archived' } } })
    if (!data) throw new Error(`GET /channels failed: ${response.status}`)
    return data.channels
  },
})

export function invalidateChannels(qc: QueryClient) {
  return qc.invalidateQueries({ queryKey: ['channels'] })
}

export function channelTitle(c: Channel) {
  return c.name ? `# ${c.name}` : 'Direct message'
}

/** DM title: the other members' names (you alone = "You (notes)"). */
export function dmTitle(c: Channel, meId: string, users: Array<{ id: string; display_name: string }>) {
  const ids = c.member_ids ?? []
  const others = ids.filter((id) => id !== meId)
  if (!others.length) return ids.length ? 'You (notes to self)' : 'Direct message'
  const name = (id: string) => users.find((u) => u.id === id)?.display_name ?? 'Someone'
  return others.map(name).join(', ')
}

export function isDirect(c: Channel) {
  return c.type === 'dm' || c.type === 'group'
}
